// extracted by mini-css-extract-plugin
export var container = "_85-0";
export var icon = "_85-1";
export var text = "_85-2";